import { FlightContainer as FlightContainerComponent } from './flightContainer'
import { ReactNode } from 'react'

interface FlightContainerProps {
    children: ReactNode
    hideGradient?: boolean
}

export const FlightContainer = ({ children, hideGradient }: FlightContainerProps) => {
    return <FlightContainerComponent hideGradient={hideGradient}>{children}</FlightContainerComponent>
}
